import { ICON_CURSOR__default, ICON_CURSOR__move_diagonal_left, ICON_CURSOR__move_diagonal_right } from '@/assets/icons_static';
import { use_effect } from '@/hooks/_base/use_effect';
import { FunctionComponent, SVGProps } from 'react';

export function HOOK_REACT_CROP__cursors() {
  /*
   * STORE
   */

  /*
   * STATE
   */

  /*
   * EFFECTS
   */

  use_effect(() => {
    let out = create_style_tag_custom_cursors();

    return () => void document.head.removeChild(out);
  }, []);

  /*
   * METHODS
   */

  function create_style_tag_custom_cursors() {
    const out = document.createElement('style');
    out.textContent = `
      .ReactCrop__crop-selection ${get_cursor(ICON_CURSOR__default, 'move', 12, 12)}
      .ReactCrop__drag-handle ${get_cursor(ICON_CURSOR__default, 'move')}
      .ReactCrop__drag-handle.ord-nw ${get_cursor(ICON_CURSOR__move_diagonal_left, 'nw-resize', 12, 12)}
      .ReactCrop__drag-handle.ord-ne ${get_cursor(ICON_CURSOR__move_diagonal_right, 'ne-resize', 12, 12)} 
      .ReactCrop__drag-handle.ord-sw ${get_cursor(ICON_CURSOR__move_diagonal_right, 'sw-resize', 12, 12)}
      .ReactCrop__drag-handle.ord-se ${get_cursor(ICON_CURSOR__move_diagonal_left, 'se-resize', 12, 12)}
      .ReactCrop:not(.ReactCrop--crop-selection) ${get_cursor(ICON_CURSOR__default, 'default')}
    `;

    document.head.appendChild(out);

    return out;
  }

  function get_cursor(cursor: FunctionComponent<SVGProps<SVGSVGElement>>, cursor_type: string, x = -12, y = -12) {
    return `{ cursor: url("${cursor}") ${x} ${y}, ${cursor_type} !important; }`;
  }
}
